import { Phone, ArrowUp } from "lucide-react";
import { useState, useEffect } from "react";

export const FloatingCTA = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 600);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Mobile sticky bottom bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-lg px-4 py-2.5 flex gap-2" data-testid="sticky-bottom-bar">
        <a href="tel:5147755027" className="flex-1 flex items-center justify-center gap-2 bg-[#2D5A3D] text-white py-2.5 rounded-lg font-medium text-sm">
          <Phone className="w-4 h-4" />Appeler
        </a>
        <button onClick={scrollToContact} className="flex-1 flex items-center justify-center gap-2 bg-white border-2 border-[#2D5A3D] text-[#2D5A3D] py-2.5 rounded-lg font-medium text-sm">
          Soumission gratuite
        </button>
      </div>

      {/* Scroll to top */}
      {showScroll && (
        <button onClick={scrollToTop} className="hidden lg:flex fixed bottom-6 right-6 z-40 w-10 h-10 bg-[#2D5A3D] text-white rounded-full shadow-lg items-center justify-center hover:bg-[#234A30] transition-colors" data-testid="scroll-top-btn">
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
};
